import { render, staticRenderFns } from "./show-grid-block.vue?vue&type=template&id=58072233&scoped=true"
import script from "./show-grid-block.vue?vue&type=script&setup=true&lang=js"
export * from "./show-grid-block.vue?vue&type=script&setup=true&lang=js"
import style0 from "./show-grid-block.vue?vue&type=style&index=0&id=58072233&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58072233",
  null
  
)

export default component.exports